import PropTypes from "prop-types";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import adminConstant from "../../../util/adminConstant";

const { MODAL_TYPE_DETAIL } = adminConstant;

function EventTypeDisableModal( props ) {
  let msg = "Enable";

  if( props?.modalData === MODAL_TYPE_DETAIL.ACTIVE_EVENT_TYPE.type ) {
    msg = "Disable";
  }

  const eventTypeData = props?.eventTypeData;
  const [ offerListToggle, setOfferListToggle ] = useState( { offerList: false, action: "show" } );

  const toggle = ( type ) => {
    if( type === "offers" ) {
      if( offerListToggle.offerList === false ) {
        setOfferListToggle( { offerList: "show-all", action: "hide" } );
      }
      else {
        setOfferListToggle( { offerList: false, action: "show" } );
      }
    }
  };

  return (
    <>
      <Modal
        show={props?.isOpened}
        centered
        className='event-disable-modal'
      >
        <Modal.Header>
          <h2 className='modal-heading'>{msg} an Event Type?</h2>
        </Modal.Header>
        <Modal.Body className='event-modal'>
          <p>Once you {msg.toLocaleLowerCase()} this event type the associated offers
            will also be {msg.toLocaleLowerCase()}d.</p>

          <div className="heading-with-button">
            <h4>Offers ({eventTypeData?.offerListCount})</h4>
            <a href="javascript:void(0)" title={offerListToggle?.action}
              className="link-text" onClick={() => toggle( "offers" )}>
              {eventTypeData?.offerListCount > 0 && offerListToggle.action}</a>
          </div>
          <ul className={`game-list scrollbar small ${ offerListToggle?.offerList }`}>
            {eventTypeData?.offerList?.map( ( offer, i ) => (
              <li key={i}>
                <span className="game-name">{offer.offerName} ({offer.gameName}) </span>
              </li>
            ) )}
          </ul>

        </Modal.Body>
        <Modal.Footer>

          <Button
            variant='outline-primary'
            className='btn-md'
            onClick={() =>
              props.onConfirm( props.modalData )
            }
          >
            Confirm
          </Button>
          <Button
            variant='primary'
            className='btn-md'
            onClick={() => props.onClose( )}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

EventTypeDisableModal.propTypes = {
  eventTypeData: PropTypes.object,
  modalData: PropTypes.string,
  isOpened: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default EventTypeDisableModal;
